module.exports = __webpack_public_path__ + "img/perforaciones_16-9_1440.d1f15d7a.jpg";